import * as React from 'react'

type UserListPageProps = IUserListPageProps

interface IUserListPageProps {}

export const UserListPage: React.FC<UserListPageProps> = props => {
  return <span />
}
